module.exports = __webpack_public_path__ + "59123000fb5ef254a904350848dd057c.png";